/**
 * Determina o turno baseado na hora atual e timezone
 * @param {string} timeZoneId - ID do timezone (ex: 'America/Sao_Paulo')
 * @returns {string} 'Manhã' ou 'Tarde'
 */
export function getTurnoAtual(timeZoneId = 'America/Sao_Paulo') {
  const now = new Date();
  const horaLocal = new Date(
    now.toLocaleString('en-US', { timeZone: timeZoneId })
  );
  const hora = horaLocal.getHours();

  return hora < 12 ? 'Manhã' : 'Tarde';
}

/**
 * Formata data para exibição
 */
export function formatDate(date) {
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(new Date(date));
}

